/**
 * FairwayBid – Wiederbeschaffung
 *
 * Range-Bälle sind Verbrauchsmaterial, Matten und Netze haben Standzeiten.
 * Ein Club merkt das meistens erst, wenn die Saison schon läuft – und
 * beschafft dann unter Zeitdruck zu schlechteren Preisen.
 *
 * Wir wissen, wann er zuletzt ausgeschrieben hat: Es steht in seinen eigenen
 * Anfragen. Daraus wird ein Hinweis zur richtigen Zeit und ein Knopf, der die
 * alte Anfrage als Grundlage nimmt.
 *
 * Die Intervalle sind Erfahrungswerte für den Range-Betrieb, keine Zusage.
 * Eher zu früh erinnern als zu spät: Zu früh kostet einen Blick, zu spät eine
 * Beschaffung ohne Vergleich.
 */

export const REORDER_MONTHS = {
  'range-golfballs-listing-type': 10,
  'range-matten': 30,
  ballwaschmaschinen: 84,
  ballautomaten: 96,
  'netze-systeme': 96,
  ballsammler: 60,
};

const MS_PER_MONTH = 30.44 * 24 * 60 * 60 * 1000;

const categoryOf = listing => {
  const pd = listing?.attributes?.publicData || {};
  return pd.categoryLevel1 || pd.categoryLevel2 || pd.category || null;
};

export const monthsSincePublished = (listing, now = new Date()) => {
  const published = listing?.attributes?.publishedAt || listing?.attributes?.createdAt;
  if (!published) return null;
  const d = published instanceof Date ? published : new Date(published);
  if (Number.isNaN(d.getTime())) return null;
  return Math.floor((now.getTime() - d.getTime()) / MS_PER_MONTH);
};

/**
 * Anfragen, für die eine Wiederbeschaffung fällig ist.
 * Je Kategorie nur die jüngste – sonst erinnern wir dreimal an dasselbe.
 *
 * @returns {Array<{listing: Object, category: string, months: number, due: number}>}
 */
export const getReorderSuggestions = (listings = [], now = new Date()) => {
  const list = Array.isArray(listings) ? listings : [];
  const newestPerCategory = {};

  list.forEach(listing => {
    const category = categoryOf(listing);
    const due = REORDER_MONTHS[category];
    const months = monthsSincePublished(listing, now);
    if (!category || !due || months === null) return;

    const current = newestPerCategory[category];
    if (!current || months < current.months) {
      newestPerCategory[category] = { listing, category, months, due };
    }
  });

  return Object.values(newestPerCategory)
    .filter(entry => entry.months >= entry.due)
    .sort((a, b) => b.months - a.months);
};
